export class TreasuryFullModuleTransferDto {
  id?: number;
  date: Date;
  transferFilter?: string;
  sourceId?: number;
  source: string;
  merchantId: string;
  merchant: string;
  amount: number;
  fireTransferId?: string;
  fireBatchId?: string;
  fireId: number;
  totalRecords?: number;
  totalPayments?: number;
  totalRefunds?: number;
}

export class TreasuryFullModuleTransferPaginatedDto {
  code?: string;
  items: TreasuryFullModuleTransferDto[];
  meta?: any;
  links?: any;
}

export class TreasuryFullModuleTransferResponseDto {
  items: TreasuryFullModuleTransferDto[];
  meta?: any;
  links?: any;
  transferTypePaginated?: TreasuryFullModuleTransferPaginatedDto[];
}
